/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateKeyByRowIdInput = {|
  clientMutationId?: ?string,
  patch: KeyPatch,
  rowId: any,
|};
export type KeyPatch = {|
  deprecated?: ?boolean,
  deprecatedAt?: ?any,
|};
export type expireKeyMutationVariables = {|
  input: UpdateKeyByRowIdInput
|};
export type expireKeyMutationResponse = {|
  +updateKeyByRowId: ?{|
    +key: ?{|
      +id: string,
      +rowId: any,
      +deprecated: boolean,
      +deprecatedAt: ?any,
    |}
  |}
|};
export type expireKeyMutation = {|
  variables: expireKeyMutationVariables,
  response: expireKeyMutationResponse,
|};
*/


/*
mutation expireKeyMutation(
  $input: UpdateKeyByRowIdInput!
) {
  updateKeyByRowId(input: $input) {
    key {
      id
      rowId
      deprecated
      deprecatedAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateKeyByRowIdInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateKeyPayload",
    "kind": "LinkedField",
    "name": "updateKeyByRowId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Key",
        "kind": "LinkedField",
        "name": "key",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deprecated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deprecatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "expireKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "expireKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "expireKeyMutation",
    "operationKind": "mutation",
    "text": "mutation expireKeyMutation(\n  $input: UpdateKeyByRowIdInput!\n) {\n  updateKeyByRowId(input: $input) {\n    key {\n      id\n      rowId\n      deprecated\n      deprecatedAt\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ba9b85f5956f1cb3843d5d2ff26fb474';

module.exports = node;
